<template>
  <div class="content">
    <h2 class="pl-3">{{ father }} | Info Materias</h2>
    <v-dialog v-model="dialogProfesorMateria" width="800px">
      <v-card style="overflow: hidden">
        <v-card-title class="grey lighten-4 py-4 title"
          >Asignar Docente</v-card-title
        >
        <listadoDocentes
          :listaDocentes="docentes"
          :idmateria_agrupamiento="materiaAgrupamiento"
          @listadoDocentes:obtenerListadoProfesores="obtenerListadoProfesores"
        />
      </v-card>
    </v-dialog>
    <v-row align-center justify="center">
      <v-col cols="11">
        <v-row justify="center">
          <v-col cols="2" class="input">
            <v-select
              v-model="cursoSeleccionado"
              ref="cursoList"
              :items="cursos"
              item-text="descripcion"
              item-value="id"
              label="Cursos"
              @change="obtenerMateriasDeCurso()"
            ></v-select>
          </v-col>
          <v-col cols="2" v-if="cursoSeleccionado != ''" class="input">
            <v-select
              v-model="materiaAgrupamiento"
              ref="materiaList"
              :items="materias"
              item-text="materia"
              item-value="id"
              label="Materia"
              @change="obtenerInfoDeMateria()"
            ></v-select>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <template v-if="cursoSeleccionado != '' && materiaAgrupamiento != ''">
      <v-row no-gutters class="pr-2">
        <v-col align="right">
          <v-btn
            depressed
            class="success white--text"
            color="success"
            @click="mostrarOcultarDialogProfesorMateria"
          >
            <v-icon left>mdi-plus-circle</v-icon>
            <span>Asignar Nuevo Docente</span>
          </v-btn>
        </v-col>
      </v-row>
    </template>
    <template v-if="infoMateria != ''">
      <div class="text-left pa-3 ma-3">
        <v-row>
          <v-col>
            <h2 class="title">{{ infoMateria.materia }}</h2>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="4">
            <h3>Profesor/es a Cargo:</h3>
          </v-col>
          <v-col cols="4">
            <h3>Horas</h3>
          </v-col>
          <v-col cols="4">
            <h3>Estado</h3>
          </v-col>
        </v-row>
        <div v-if="infoMateria.profesores.length > 0" class="profesores">
          <template v-for="(profesor, index) in infoMateria.profesores">
            <v-row :key="index" class="fila_profesor">
              <v-col cols="4">{{ profesor.nombre }}</v-col>
              <v-col cols="4">{{ profesor.horas }}</v-col>
              <v-col cols="4">
                <!--<v-icon color="success">check_circle</v-icon>-->
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-icon
                      v-on="on"
                      @click="
                        editarEstadoProfesorMateria(
                          profesor.idprofesor_materia,
                          profesor.estado
                        )
                      "
                      :class="[
                        profesor.estado == '1' ? 'greenColor' : 'redColor',
                      ]"
                      >{{
                        profesor.estado == "1"
                          ? "mdi-chevron-down-circle"
                          : "mdi-close-circle"
                      }}</v-icon
                    >
                  </template>
                  <span>{{
                    profesor.estado == "1" ? "Habilitado" : "Deshabilitado"
                  }}</span>
                </v-tooltip>
              </v-col>
            </v-row>
          </template>
        </div>
        <!--<v-row v-else class="msj">
          <v-col>
            <label class="msj">No hay Docente(s) Asignado/a(s)</label>
          </v-col>
        </v-row>-->
      </div>
      <!--<v-btn>Asignar Docente</v-btn>-->
    </template>
    <template
      v-if="
        cursoSeleccionado != '' &&
        materiaAgrupamiento != '' &&
        infoMateria == ''
      "
    >
      <v-row class="msj">
        <v-col align="center" justify="center">
          <label class="msj">No hay Docente(s) Asignado/a(s)</label>
        </v-col>
      </v-row>
    </template>
  </div>
</template>

<script>
import API from "@/components/_config/conf";
import listadoDocentes from "./listadoDocentes";

export default {
  data() {
    return {
      dialogProfesorMateria: false,
      materiaAgrupamiento: "",
      cursoSeleccionado: "",
      cursos: [],
      materias: [],
      infoMateria: "",
      docentes: [],
    };
  },
  props: ["father"],
  components: {
    listadoDocentes,
    //alumno
  },
  mounted: function () {
    let resultado = API.enviar("get", "obtenerCursos", "");
    //console.log("Acá !!!");
    resultado
      .then((result) => {
        if (result.data.msj == "ok") this.cursos = result.data.result;
      })
      .catch(() => {
        //console.log("catch obtenerMateriasDeProfesor-> params: ", params);
      });
  },
  methods: {
    mayusculas: function (string) {
      let string_aux = API.ucFirst(string);
      return string_aux;
    },
    obtenerMateriasDeCurso: function () {
      //console.log("obtenerMateriasCurso", this.cursoSeleccionado);
      //this.mostrarNotas = false;
      this.materiaAgrupamiento = "";
      this.infoMateria = "";
      let params = "curso=" + this.cursoSeleccionado;
      let resultado = API.enviar("get", "obtenerMateriasCurso", params);

      resultado
        .then((result) => {
          //console.log(result);
          if (result.data.msj == "ok") this.materias = result.data.result;
          else this.materias = [];
          //this.materiasCant = result.data.length;
        })
        .catch(() => {
          //console.log("catch obtenerMateriasDeProfesor-> params: ", params);
        });
    },
    obtenerInfoDeMateria: function () {
      //console.log(this.materiaAgrupamiento);

      let params = "idmateria_agrupamiento=" + this.materiaAgrupamiento;
      let resultado = API.enviar("get", "obtenerInfoMateria", params);

      resultado
        .then((result) => {
          if (result.data.msj == "ok") this.infoMateria = result.data.result;
          else this.infoMateria = "";
          /*console.log(
            "Info Mat: ",
            this.infoMateria.profesores,
            this.infoMateria.profesores.length
          );*/
        })
        .catch(() => {});
    },
    mostrarOcultarDialogProfesorMateria: function () {
      this.dialogProfesorMateria = !this.dialogProfesorMateria;
      this.obtenerListadoProfesores();
    },
    obtenerListadoProfesores() {
      let params = "idmateria_agrupamiento=" + this.materiaAgrupamiento;
      let resultado = API.enviar("get", "obtenerProfesoresParaMateria", params);
      resultado
        .then((result) => {
          //console.log(result);
          if (result.data.msj == "ok")
            //this.materias = result.data.result;
            this.docentes = result.data.result;
          //console.log(result.data.result);
          //this.materiasCant = result.data.length;
        })
        .catch(() => {
          //console.log("catch obtenerMateriasDeProfesor-> params: ", params);
        });
      //console.log(this.infoMateria.profesores);
    },
    editarEstadoProfesorMateria(idProfesorMateria, estado) {
      let nuevo_estado;
      estado == "1" ? (nuevo_estado = "0") : (nuevo_estado = "1");

      let params = "idProfesorMateria=" + idProfesorMateria;
      params += "&estadoProfesorMateria=" + nuevo_estado;

      let resultado = API.enviar("get", "editarEstadoProfesorMateria", params);

      resultado
        .then(() => {
          this.obtenerInfoDeMateria();
        })
        .catch(() => {
          //console.log("catch obtenerMateriasDeProfesor-> params: ", params);
        });
    },
  },
  watch: {
    dialogProfesorMateria: function () {
      //console.log(this.dialogProfesorMateria);
      if (!this.dialogProfesorMateria) this.obtenerInfoDeMateria();
      //console.log("Watch: ", this.dialogProfesorMateria);
    },
  },
};
</script>

<style scoped>
.content {
  width: 100%;
}

h2 {
  padding-bottom: 20px;
  /*padding-left: 5px;*/
  /*background-color: #ccc;*/
}

.title {
  padding-top: 20px;
  padding-left: 10px;
  background-color: #ccc;
  opacity: 0.8;
}

h3 {
  padding: 10px 0 10px 0;
  border-bottom: solid 1px #ccc;
  border-top: solid 1px #ccc;
}

.input {
  padding: 5px;
}

.profesores {
  padding: 0px 20px 20px 20px;
  font-size: 18px;
}

.fila_profesor {
  padding-top: 10px;
  border-bottom: solid 1px #ccc;
}

.msj {
  padding: 15px 15px 15px 0px;
}

.greenColor {
  color: green;
}
.redColor {
  color: red;
}
.v-icon {
  cursor: pointer;
}
</style>